// eslint-disable-next-line
import { h, Component } from 'preact';
import USC from './ui/components/USC';

import './styles/scss/index.scss';

const Root = () => <USC />;

export default Root;
